import rightArrow from "images/right-arrow.svg";
import {useEffect, useState} from "react";
import {strings} from "strings";

import LoadingSpinner from "components/LoadingSpinner";
import SearchInput from "components/SearchInput";

import {useSearchPharmacy} from "liberty-core/api/react-query/pharmacy";

import styles from "./PharmacyLookupPage.module.css";

const DEBOUNCE_SEARCH_MS = 500;
const MIN_SEARCH_TO_TRIGGER_API = 3;
const DOMAIN = process.env.REACT_APP_IS_QA === "true" ? "test.rx365" : "rx365";

export default function PharmacyLookupPage() {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const {data: searchResults, isLoading} = useSearchPharmacy(
    {searchText: debouncedSearch, isWebSearch: true},
    {
      enabled:
        debouncedSearch !== "" &&
        debouncedSearch.length >= MIN_SEARCH_TO_TRIGGER_API,
    },
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, DEBOUNCE_SEARCH_MS);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  return (
    <>
      <div className={styles.upperContent}>
        <div className={styles.contentTitle}>{strings.pharmacyLookup}</div>
        <div className={styles.contentDescription}>{strings.searchBy}</div>
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={strings.placeholder}
        />
      </div>
      {isLoading ? (
        <div className={styles.loadingSpinnerContainer}>
          <LoadingSpinner />
        </div>
      ) : searchResults?.length ? (
        <div className={styles.resultsContainer}>
          {searchResults?.map((s) => (
            <a
              key={s.id}
              className={styles.result}
              href={
                s.subdomain
                  ? `https://${s.subdomain}.${DOMAIN}.com`
                  : `https://${DOMAIN}.com`
              }
            >
              <div>
                <div className={styles.resultName}>{s.name}</div>
                <div className={styles.resultAddress}>
                  {s.address.street1} {s.address.street2 ?? ""}
                </div>
                <div className={styles.resultAddress}>
                  {s.address.city}, {s.address.state} {s.address.zip}
                </div>
              </div>
              <img src={rightArrow} alt="" />
            </a>
          ))}
        </div>
      ) : null}
    </>
  );
}
